import { render, staticRenderFns } from "./MontagemCargaForm.vue?vue&type=template&id=78a9ef3d"
import script from "./MontagemCargaForm.vue?vue&type=script&lang=js"
export * from "./MontagemCargaForm.vue?vue&type=script&lang=js"
import style0 from "./MontagemCargaForm.vue?vue&type=style&index=0&id=78a9ef3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports